import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { CanvasserDetail } from '@/components/analytics';
import { useCanvasserStats, useShifts, useContactAnalytics, useCanvasserPerformance } from '@/hooks/queries';
import type { CanvasserAnalyticsFilters } from '@/lib/queryKeys';

export const Route = createFileRoute('/app/analytics/canvassers/$userId')({
  component: CanvasserDetailRoute,
});

function CanvasserDetailRoute() {
  const { userId } = Route.useParams();
  const filters = Route.useSearch() as CanvasserAnalyticsFilters;
  const navigate = useNavigate();

  const { data: canvasserStatsResponse, isLoading: isLoadingStats } = useCanvasserStats({
    ...filters,
    userId,
  });
  const canvasserStats = canvasserStatsResponse?.items;
  const benchmarks = canvasserStatsResponse?.benchmarks;
  const { data: shifts, isLoading: isLoadingShifts } = useShifts({
    claimedById: userId,
    startDate: filters.dateFrom,
    endDate: filters.dateTo,
  });
  const { data: contactAnalytics, isLoading: isLoadingContacts } = useContactAnalytics(userId);
  const { data: performanceData, isLoading: isLoadingPerformance } = useCanvasserPerformance(userId);

  const handleBack = () => {
    navigate({
      to: '/app/analytics',
      search: filters,
    });
  };

  return (
    <CanvasserDetail
      userId={userId}
      canvasserStats={canvasserStats ?? []}
      shifts={shifts}
      contactAnalytics={contactAnalytics}
      isLoadingStats={isLoadingStats}
      isLoadingShifts={isLoadingShifts}
      isLoadingContacts={isLoadingContacts}
      onBack={handleBack}
      benchmarks={benchmarks}
      performanceData={performanceData}
      isLoadingPerformance={isLoadingPerformance}
    />
  );
}
